<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-24
    	描述：后台系统首页
    -->
  <div class="home" >
  <div>
    <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline" >
   
    <div style="margin-top: 20px;">
      
      <el-select  placeholder="快捷选择"  @change="quickClick"  v-model="formInline.quick" size="small">
        <el-option label="请选择功能" :value="0"></el-option>
        <el-option label="进行中的订单" :value="5"></el-option>    
        <el-option label="所有批发点位置" :value="1"></el-option>
        <el-option label="所有司机位置" :value="2"></el-option>
        <el-option label="所有司机实时位置" :value="6"></el-option>
        <el-option label="所有业务员位置" :value="3"></el-option>
        <el-option label="所有业务员实时位置" :value="7"></el-option>
        <el-option label="所有门店位置" :value="4"></el-option>     
         
      </el-select>
      
      <el-form-item label="批发点" v-if="formInline.quick == 1">
          <el-input v-model="formInline.search" placeholder="批发点名称/手机号"></el-input>
        </el-form-item>
        <el-form-item label="司机"  v-if="formInline.quick == 2 || formInline.quick ==6">
          <el-input v-model="formInline.search" placeholder="司机名称/手机号"></el-input>
        </el-form-item>
        <el-form-item label="业务员"  v-if="formInline.quick == 3 || formInline.quick == 7">
          <el-input v-model="formInline.search" placeholder="业务员名称/手机号"></el-input>
        </el-form-item>

        <el-form-item label="门店"  v-if="formInline.quick == 4">
          <el-input v-model="formInline.search" placeholder="门店名称/手机号"></el-input>
        </el-form-item>

        <el-form-item label="订单"  v-if="formInline.quick == 5">
          <el-input v-model="formInline.search" placeholder="发货单订单号"></el-input>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search" >查询</el-button>
        </el-form-item>
    </div>

    <div>只获取有地址的数据</div>
   
      </el-form>



    <div id="map-container" style="width:100%; height:500px"></div>

  </div>

  
  </div>
</template>

<script>
import IndexApi from "@/api/index.js";


export default {
  data() {
    return {
  
        //地图
        myChart: null,
            //地图
      map: null,
      marker: null,
      polyline: null,
      passedPolyline: null,
      selectedDate: [],
      markerArr: [], //电池经纬度,也用于画线
      startIcon: '',
      endIcon: '',
      formInline:{
        quick:5,

        search:""
      },
      detail:{

      },
   

    };
  },
  mounted(){
     // 地图初始化代码
     const script = document.createElement('script');
    script.src = 'https://webapi.amap.com/maps?v=1.4.15&key=16e7503e2bdb0605334458a3d3bd1f02';
    script.async = true;
    document.head.appendChild(script);
  },

  created() {
    var self = this;
    setTimeout(() => {
      self.initMap();
    },200)

  },
  methods: {
    search(){
      this.quickClick();
    },

    quickClick(){
      var self= this;
      var parmas = self.formInline;
      if(parmas.type == 0){
        return false;
      }
      IndexApi.getRole(parmas)
        .then((data) => {
          self.map.clearMap();   
   
          if(data.data.type == 5){
              self.detail = data.data.val.line;

              self.map = new AMap.Map("map-container", {
            resizeEnable: true,
            zoom: 7,
            center: [ self.detail.peisong [0].longitude, self.detail.peisong[0].latitude] //地图中心点
          });
          self.GetBatteryHistory();
              for(var i=0;i< self.detail.peisong.length;i++){
              var el_i =  self.detail.peisong[i];
            
              // var img = "";
              //   if(el_i.type == 'driver'){
              //     img = "https://webapi.amap.com/images/car.png";
              //   }else  if(el_i.type == "saler"){
              //     img = './static/saler.png'
              //   }else if(el_i.type == 'store'){
              //     img = './static/store_address.png'
              //   }
                
              //   var ma = new AMap.Marker({
              //     map: self.map,
              //     //小车出初始位置
              //     position: [el_i.lng,el_i.lat],
              //     icon: img,
              //     offset: new AMap.Pixel(-26, -13),
                
              //   });  

                // 为标记绑定点击事件
                ma.on('click', (function(el_i, ma) {
                    return function() {
                        // 动态创建 InfoWindow，显示该标记对应的内容
                        var infoWindow = new AMap.InfoWindow({
                            content: `<div>
                                        <strong>${el_i.name}</strong><br>
                                        联系方式: ${el_i.mobile}
                                      </div>`,
                            offset: new AMap.Pixel(0, -30) // 偏移量
                        });

                        // 打开当前标记的 InfoWindow
                        infoWindow.open(self.map, ma.getPosition());
                    };
                })(el_i, ma));  // 使用自执行函数立即捕获 el_i 和 ma
    
          }

   
          }else{
          
            if(data.data.data.length > 0){
        
       
            self.map = new AMap.Map("map-container", {
            resizeEnable: true,
            zoom: 7,
            center: [data.data.data[0].lng, data.data.data[0].lat] //地图中心点
          });

          for(var i=0;i<data.data.data.length;i++){
            var el_i = data.data.data[i];
           
            var img = "";
              if(el_i.type == 'driver'){
                img = "https://webapi.amap.com/images/car.png";
              }else  if(el_i.type == "saler"){
                img = './static/saler.png'
              }else if(el_i.type == 'store'){
                img = './static/store_address.png'
              }else if(el_i.type == 'company'){
                img = './static/company.png'
              }
              
              var ma = new AMap.Marker({
                map: self.map,
                //小车出初始位置
                position: [el_i.lng,el_i.lat],
                icon: img,
                offset: new AMap.Pixel(-26, -13),
              
              });  

              // 为标记绑定点击事件
              ma.on('click', (function(el_i, ma) {
                  return function() {
                      // 动态创建 InfoWindow，显示该标记对应的内容
                      var infoWindow = new AMap.InfoWindow({
                          content: `<div>
                                      <strong>${el_i.name}</strong><br>
                                      联系方式: ${el_i.mobile}
                                    </div>`,
                          offset: new AMap.Pixel(0, -30) // 偏移量
                      });

                      // 打开当前标记的 InfoWindow
                      infoWindow.open(self.map, ma.getPosition());
                  };
              })(el_i, ma));  // 使用自执行函数立即捕获 el_i 和 ma
   
         }
         setTimeout(() => {
          self.map.setFitView();
          }, 500);
          }
          
        
        }
      

    

        })
        .catch((error) => {});
    },
   /*创建图表对象*/
   initMap() {
      let that = this;
      if(that.formInline.quick == 5){
          that.map = new AMap.Map("map-container", {
            resizeEnable: true,
            zoom: 7,
            center: [116.397428, 39.90923] //地图中心点
          });
          AMap.plugin(["AMap.ToolBar"], function() {
            //加载工具条
            var tool = new AMap.ToolBar();
            that.map.addControl(tool);
          });
          //清除地图的所有覆盖物
          that.map.clearMap();
      
      }else{
        that.map = new AMap.Map("map-container", {
          resizeEnable: true,
          zoom: 7,
          center: [116.397428, 39.90923] //地图中心点
        });
        AMap.plugin(["AMap.ToolBar"], function() {
          //加载工具条
          var tool = new AMap.ToolBar();
          that.map.addControl(tool);
        });
        //清除地图的所有覆盖物
        that.map.clearMap();
        //电池经纬度,也用于画线
        this.markerArr = [];
        this.GetBatteryHistory();
      }
 
    },
       //获取轨迹数据
       GetBatteryHistory() {
      let that = this;
      //接口获得数据后转换，高德接受的数据格式为[[111.11,122.22],[111.11,123.33]]
      setTimeout(() => {
        //坐标点数组转换
        console.log('that.detail.line.info',that.detail.line.info)
        if(that.detail && that.detail.line && that.detail.line.info){
          var marker = that.detail.line.info;//[[116.478935,39.997761],[116.478939,39.997825],[116.478912,39.998549],[116.478912,39.998549],[116.478998,39.998555],[116.478998,39.998555],[116.479282,39.99856],[116.479658,39.998528],[116.480151,39.998453],[116.480784,39.998302],[116.480784,39.998302],[116.481149,39.998184],[116.481573,39.997997],[116.481863,39.997846],[116.482072,39.997718],[116.482362,39.997718],[116.483633,39.998935],[116.48367,39.998968],[116.484648,39.999861]]
        
        marker.map(ele => {
            let tempArr = [];
            tempArr.push(ele[0]);
            tempArr.push(ele[1]);

            that.markerArr.push(tempArr);
        });
        
        that.$nextTick(() => {
          //画线
          that.playLine();
        });
        }
  
     
      }, 1000);
    },


    //画线
    playLine() {
      let that = this;
      console.log('that.markerArr',that.markerArr)
      //初始化起点终点
      that.initStartEnd();

      for(var i =0;i<that.detail.peisong.length;i++){
        var el_i = that.detail.peisong[i];
  
        if(el_i.type == 1){
           var ma =  new AMap.Marker({
              map: that.map,
          
              position: [el_i.longitude,el_i.latitude],
              icon: "./static/warehouse.png",
      
            });
     
          }else if(el_i.type == 2){
            var ma =  new AMap.Marker({
              map: that.map,
             
              position: [el_i.longitude,el_i.latitude],
              icon: "./static/store.png",
      
            });
  
          }

  


                  // 为标记绑定点击事件
                  ma.on('click', (function(el_i, ma) {
                  return function() {
                      // 动态创建 InfoWindow，显示该标记对应的内容
                      var infoWindow = new AMap.InfoWindow({
                          content: `<div>
                                      <strong>${el_i.name}</strong><br>
                                      地址: ${el_i.address}
                                    </div>`,
                          offset: new AMap.Pixel(0, -30) // 偏移量
                      });

                      // 打开当前标记的 InfoWindow
                      infoWindow.open(that.map, ma.getPosition());
                  };
              })(el_i, ma));  // 使用自执行函数立即捕获 el_i 和 ma


      }
  

      // 绘制轨迹
      that.polyline = new AMap.Polyline({
        map: that.map,
        path: that.markerArr,
        showDir: true,
        strokeColor: "#28F", //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 //线宽
        // strokeStyle: "solid"  //线样式
      });
      //自适应放大
      setTimeout(() => {
        that.map.setFitView();
      }, 500);
    },
    //初始化起点终点
    initStartEnd() {
      let that = this;
      let startMarker = new AMap.Marker({
        position: new AMap.LngLat(that.markerArr[0][0], that.markerArr[0][1]),
        icon: that.startIcon,
        offset: new AMap.Pixel(-13, -30)
      });
      //将icon添加进marker
      let endMarker = new AMap.Marker({
        position: new AMap.LngLat(
          that.markerArr.pop()[0],
          that.markerArr.pop()[1]
        ),
        icon: that.endIcon,
        offset: new AMap.Pixel(-13, -30)
      });
      // 将 markers 添加到地图
      that.map.add([startMarker, endMarker]);

 
    },
  
  },
};
</script>

<style lang="scss" scoped>
.operation-wrap {
  width: 100%;

  border-radius: 8px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 0 30px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  background: #3a8ee6;
  background-size: 100% 100%;
  color: #fff;

}

.operation-wrap .grid-content {
  height: 164px;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.operation-wrap .grid-content h3 {
  font-size: 36px;
  line-height: 40px;
}

.operation-wrap .grid-content .info {
  margin-left: 10px;
}

.operation-wrap .grid-content .svg-icon {
  color: #ffffff;
}

.home-index {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  min-width: 1000px;
  overflow-x: auto;
}

.main-index {
  flex: 1;
}

.main-index .grid-content,
.operation-wrap .grid-content {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.main-index .grid-content {
  height: 120px;
}

.main-index .grid-content .pic {
  margin-right: 10px;
}

.main-index .grid-content h3 {
  font-size: 20px;
  font-weight: normal;
}

.main-index .grid-content .yesterday {
  color: #ccc;
}

.main-index .grid-content .svg-icon {
  color: #3a8ee6;
}

.matters-wrap .matters {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 120px;
}

.matters-wrap .matters .title {
  font-size: 14px;
  color: #fff;
  display: inline-block;
  height: 20px;
  line-height: 20px;
  width: 40px;
  text-align: center;
  border-radius: 99px;
  margin-bottom: 20px;
  background: #3a8ee6;
}

.matters-wrap .matters ul {
  color: #999999;
}

.matters-wrap .matters ul span {
  padding-right: 6px;
  color: #3a8ee6;
}

.markert-wrap .market {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.markert-wrap .market-box {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 20px;
}
.markert-wrap .market-box .el-image {
  width: 150px;
  height: 150px;
  margin-bottom: 2px;

}

.markert-wrap .market-box p {
  font-size: 14px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/home/map.vue